// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-container[data-v-3cd04d85] {\n  margin-bottom: 30px;\n  cursor: pointer;\n}\n.item-title[data-v-3cd04d85] {\n  font-size: 18px;\n  font-weight: bold;\n}\n.item-content[data-v-3cd04d85] {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
